import React from 'react';

const LiveBadge = ({ size = 'default' }) => {
  const sizeClasses = {
    small: 'text-xs px-2 py-1',
    default: 'text-sm px-3 py-1.5',
    large: 'text-base px-4 py-2'
  };

  return (
    <div className={`inline-flex items-center gap-2 bg-red-600 text-white font-bold rounded ${sizeClasses[size]} animate-pulse`}>
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
      </span>
      🔴 EN DIRECT
    </div>
  );
};

export default LiveBadge;
